import axios from 'axios';

export default {
  state: {
    productsViewed: {},
    loading: false,
    error: null,
    productsViewedLoaded: false
  },
  mutations: {
    SET_PRODUCTS_VIEWED(state, product) {
      state.productsViewed = product;
      state.productsViewedLoaded = true; // Устанавливаем флаг, что данные загружены
    },
    SET_PRODUCTS_VIEWED_LOADING(state, status) {
      state.productsViewedLoading = status;
    },
    SET_PRODUCTS_VIEWED_ERROR(state, error) {
      state.productsViewedError = error;
    },
    UNSET_PRODUCTS_VIEWED(state) {
      state.productsViewedLoaded = false;
      state.productsViewedLoading = false;
      state.productsViewed = [];
    },
  },
  actions: {
    async fetchProductsViewed({ commit, state }) {
      // Проверяем, были ли категории уже загружены
      if (state.loaded && state.product) {
        //return; // Если данные уже загружены, прекращаем выполнение
      }

      try {
        commit('SET_PRODUCTS_VIEWED_LOADING', true);
        // Используем относительный путь, который будет добавлен к baseURL из глобальных настроек
        const response = await axios.get('api/catalog/detail/viewed/');
        commit('SET_PRODUCTS_VIEWED', response.data.data);
        commit('SET_PRODUCTS_VIEWED_ERROR', null);
      } catch (error) {
        commit('SET_PRODUCTS_VIEWED_ERROR', error.message || 'Ошибка при загрузке категорий');
        console.error('Error fetching product:', error);
      } finally {
        commit('SET_PRODUCTS_VIEWED_LOADING', false);
      }
    }
  },
  getters: {
    productsViewed: state => state.productsViewed,
    productsViewedLoading: state => state.productsViewedLoading,
    productsViewedError: state => state.productsViewedError,
    productsViewedLoaded: state => state.productsViewedLoaded
  }
}